// Third-Party
import React, { Component } from 'react';
import classNames from 'classnames';
import Skeleton from 'react-skeleton-loader';

// Component
import { IconButton } from '../buttons';

// Utils
import { formatMessage } from '../../../utils/i18n';

// Assets
import defaultAvatar from '../../../images/user-icon.svg';
import { Avatar } from '@capintel/component-lib/avatar';
import { Button } from '@capintel/component-lib/button';

type Props = {
  comment?: string;
  isEditing: boolean;
  isPosted?: boolean;
  timestamp?: string;
  userInfos?: {
    imgUrl?: string;
    name?: string;
  };
  onChange: (event: React.FormEvent<HTMLTextAreaElement>) => void;
  editComment: () => void;
  deleteComment: () => void;
  actionsDisabled?: boolean;
};

const SKELETON_COLOR = '#70bda0';

class CommentContent extends Component<Props> {
  static defaultProps = {
    onChange: () => {},
    editComment: () => {},
    deleteComment: () => {},
  };

  onChange = (event: React.FormEvent<HTMLTextAreaElement>) => {
    this.props.onChange(event);
  };

  renderActions = () => (
    <>
      <Button variant="secondary" appearance="icon" icon="edit" onClick={this.props.editComment} />
      <Button variant="secondary" appearance="icon" icon="delete-outline" onClick={this.props.deleteComment} />
    </>
  );

  render() {
    const { comment, isPosted, isEditing, timestamp, actionsDisabled, userInfos } = this.props;

    return (
      <div className="comment-content">
        {isPosted && !isEditing && (
          <div className="top-row d-flex">
            <div className="profile-avatar">
              {!userInfos && <Skeleton color={SKELETON_COLOR} />}

              {userInfos && <Avatar image={userInfos.imgUrl || defaultAvatar} altTag="User avatar" />}
            </div>

            <div className="info d-flex flex-column flex-grow-1">
              {!userInfos && <Skeleton color={SKELETON_COLOR} />}

              {userInfos && <span className="user-name">{userInfos.name}</span>}

              {timestamp && <span className="timestamp">{timestamp}</span>}
            </div>

            {!actionsDisabled && this.renderActions()}
          </div>
        )}

        {!isEditing ? (
          <div data-private data-dd-privacy="mask" className="comment-value">
            {comment}
          </div>
        ) : (
          <textarea
            maxLength={1024}
            value={comment}
            onChange={this.onChange}
            placeholder={formatMessage('MarkupTools.Comment.Placeholder')}
            className={classNames('comment-textarea', { disabled: !isEditing })}
            data-private
            data-dd-privacy="mask"
          />
        )}
      </div>
    );
  }
}

export default CommentContent;
